import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        const months = _.range(12);
        const days = _.range(31);
        const years = props.direction == 'future'
            ? _.range( moment().year() - 1, moment().year() + 10 )
            : _.range( moment().year(), moment().year() - 100, -1 );

        this.state = {
            month: null,
            months: months,
            day: null,
            days: days,
            year: null,
            years: years,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.month && nextState.day && nextState.year && this.props.base_url) {
            document.location.href = `${this.props.base_url}/${nextState.year}-${nextState.month}-${nextState.day}`;
        }

        if (nextState.month != this.state.month) {
            return true;
        }

        if (nextState.day != this.state.day) {
            return true;
        }

        if (nextState.year != this.state.year) {
            return true;
        }

        return false;
    }

    render({ base_url }) {
        return (
            <birthday-select base_url={base_url}>
                <label>{this.renderMonths()}</label>
                <label>{this.renderDays()}</label>
                <label>{this.renderYears()}</label>
            </birthday-select>
        );
    }

    renderMonths = () => {
        return (
            <select
                onChange={this.setMonth}
                name='month'
            >
                <option selected disabled>month</option>
                {this.state.months.map(month => (
                    <option value={moment().month(month).format('MM')}>
                        {moment().month(month).format('MMMM')}
                    </option>
                ))}
            </select>
        );
    }

    setMonth = (e) => {
        this.setState({
            month: e.target.value,
            day: null,
        });
        this.getDays();
    }

    renderDays = () => {
        return (
            <select
                onChange={this.setDay}
                name='day'
            >
                <option selected disabled>day</option>
                {this.state.days.map(day => (
                    <option value={('0' + (day + 1)).substr(-2)}>{day + 1}</option>
                ))}
            </select>
        );
    }

    getDays = () => {
        const year = this.state.year ? this.state.year : this.state.years[0];
        const month = this.state.month ? this.state.month : 1;
        const daysInMonth = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();
        const days = _.range(daysInMonth);

        this.setState({
            days: days,
        });
    }

    setDay = (e) => {
        this.setState({day: e.target.value});
    }

    renderYears = () => {
        return (
            <select
                onChange={this.setYear}
                name='year'
            >
                <option selected disabled>year</option>
                {this.state.years.map(year => (
                    <option value={year}>{year}</option>
                ))}
            </select>
        );
    }

    setYear = (e) => {
        this.setState({year: e.target.value});
    }
}

export default connect()(Component);
